export const MAX_LENGTHS = {
    //Max length
    CODE: 20,
    //Max length
    NAME: 50,
    //Max length
    DESCRIPTION: 100,
    //Max length
    CSS_CLASS: 50,
    //Max length
    LONG_DESCRIPTION: 1000,
    //Max length
    NOTES: 255,
    FISCAL_DATA: {
        //Exact length
        FISCAL_CODE: 11,
        //Exact length
        VAT_NUMBER: 11,
        //Exact length
        SDI_CODE: 7,
        //Max length
        BUSINESS_NAME: 100,
        //Max length
        PEC_ADDRESS: 50,
    },
};

export const DOMAIN_CONSTANTS = {
    DEFAULT_SCALE_PRECISION: 5,
};

export const SUPPORTED_LANGS: { code: string; label: string }[] = [
    { code: 'it', label: 'languages.italian' },
    { code: 'en', label: 'languages.english' },
    { code: 'de', label: 'languages.german' },
    { code: 'fr', label: 'languages.french' },
    { code: 'es', label: 'languages.spanish' },
];

export const APP_REGEXES = {
    PHONE_NUMBER: /^\+?[0-9\s\-()]{0,19}$/,
};
